import {
    IUserManagementSearchModel,
    IUserManagementSearchRequestModel,
    IUserDownloadModel,
    IUserDownloadRequestModel,
    ISearchUserInformationModel,
    IUserManagementAddUsersRequestModel
} from '../../util/Request/requestType';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '..';

interface IUserManagemnetDataPageModel {
    userList: IUserManagementSearchModel[],
    downloadUserLists: IUserDownloadRequestModel[],
    deleteFileBoolean: boolean,
    searchUserInformations: any[],
    addUserList: any[],
    sendWelcomeEmailList: any[],
    updateUserList: any[]
}

const initialState: IUserManagemnetDataPageModel = {
    userList: [],
    downloadUserLists: [],
    deleteFileBoolean: false,
    searchUserInformations: [],
    addUserList: [],
    sendWelcomeEmailList: [],
    updateUserList:[]
};

export const userListsSlice = createSlice({
    name: 'userList',
    initialState,
    reducers: {

        getUserListAction: (state, action: PayloadAction<IUserManagemnetDataPageModel>) => {
            console.log(action);
            const newUserLists = [...action.payload.userList];
            // console.log(state);
            return {
                userList: newUserLists,
                downloadUserLists: [...state.downloadUserLists],
                deleteFileBoolean: state.deleteFileBoolean,
                searchUserInformations: [...state.searchUserInformations],
                addUserList: [...state.addUserList],
                sendWelcomeEmailList: [...state.sendWelcomeEmailList],
                updateUserList: [...state.updateUserList]
            };
        },
        deleteFile: (state, action: PayloadAction<IUserManagemnetDataPageModel>) => {
            return {
                userList: [...state.userList],
                downloadUserLists: [...state.downloadUserLists],
                deleteFileBoolean: !state.deleteFileBoolean,
                searchUserInformations: [...state.searchUserInformations],
                addUserList: [...state.addUserList],
                sendWelcomeEmailList: [...state.sendWelcomeEmailList],
                updateUserList: [...state.updateUserList]
            };
        },
        searchUserInformationAction: (state, action: PayloadAction<IUserManagemnetDataPageModel>) => {
            const newsearchUserInformations = [...action.payload.searchUserInformations];
            return {
                userList: [...state.userList],
                downloadUserLists: [...state.downloadUserLists],
                deleteFileBoolean: state.deleteFileBoolean,
                searchUserInformations: newsearchUserInformations,
                addUserList: [...state.addUserList],
                sendWelcomeEmailList: [...state.sendWelcomeEmailList],
                updateUserList: [...state.updateUserList]
            };
        },
        addUsersAction: (state, action: PayloadAction<IUserManagemnetDataPageModel>) => {
            const newAddUsers = [...action.payload.addUserList];
            return {
                userList: [...state.userList],
                downloadUserLists: [...state.downloadUserLists],
                deleteFileBoolean: state.deleteFileBoolean,
                searchUserInformations: [...state.searchUserInformations],
                addUserList: newAddUsers,
                sendWelcomeEmailList: [...state.sendWelcomeEmailList],
                updateUserList: [...state.updateUserList]
            };
        },
        sendWelcomeEmailListAction: (state, action: PayloadAction<IUserManagemnetDataPageModel>) => {
            const newsendWelcomeEmailList = [...action.payload.sendWelcomeEmailList];
            return {
                userList: [...state.userList],
                downloadUserLists: [...state.downloadUserLists],
                deleteFileBoolean: state.deleteFileBoolean,
                searchUserInformations: [...state.searchUserInformations],
                addUserList: [...state.addUserList],
                sendWelcomeEmailList: newsendWelcomeEmailList,
                updateUserList: [...state.updateUserList]
            };
        },
        updateUserAction: (state, action: PayloadAction<IUserManagemnetDataPageModel>) => {
            const newupdateUser = [...action.payload.updateUserList];
            return {
                userList: [...state.userList],
                downloadUserLists: [...state.downloadUserLists],
                deleteFileBoolean: state.deleteFileBoolean,
                searchUserInformations: [...state.searchUserInformations],
                addUserList: [...state.addUserList],
                sendWelcomeEmailList: [...state.sendWelcomeEmailList],
                updateUserList: newupdateUser
            };
        },
    }
});

export type {
    IUserManagemnetDataPageModel
};

export const {
    getUserListAction,
    deleteFile,
    searchUserInformationAction,
    addUsersAction,
    sendWelcomeEmailListAction,
    updateUserAction
} = userListsSlice.actions;

export const selectuserList = (state: RootState) => state.soilPageData;
export default userListsSlice.reducer;
